
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import Button, { ButtonGroup, ButtonLayout, ButtonPrimary } from "./../index";
import ButtonLayouts from "./../ButtonLayouts";
import Icon from "./../../Icon/index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Button Groups`}</h1>
    <p>{`Button groups merge related buttons into more complex components.`}</p>
    <h2>{`Example`}</h2>
    <ButtonGroup direction="horizontal" mdxType="ButtonGroup">
  <Button mdxType="Button">Button</Button>
  <Button mdxType="Button">Button</Button>
  <Button mdxType="Button">Button</Button>
    </ButtonGroup>
    <h2>{`Variants`}</h2>
    <h3>{`Horizontal`}</h3>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <ButtonGroup direction="horizontal" mdxType="ButtonGroup">
      <Button mdxType="Button">Button</Button>
      <Button mdxType="Button">Button</Button>
      <Button mdxType="Button">Button</Button>
    </ButtonGroup>
    <ButtonGroup direction="horizontal" mdxType="ButtonGroup">
      <ButtonPrimary size="large" mdxType="ButtonPrimary">Button</ButtonPrimary>
      <ButtonPrimary size="large" mdxType="ButtonPrimary">Button</ButtonPrimary>
      <ButtonPrimary size="large" mdxType="ButtonPrimary">
        <Icon name="heart" size="medium" mdxType="Icon" />
      </ButtonPrimary>
    </ButtonGroup>
    <ButtonGroup direction="horizontal" mdxType="ButtonGroup">
      <Button size="small" isDisabled mdxType="Button">
        Button
      </Button>
      <Button size="small" mdxType="Button">Button</Button>
      <Button size="small" mdxType="Button">
        <Icon name="heart" className="icon--left" mdxType="Icon" />
        Button
      </Button>
    </ButtonGroup>
  </ButtonLayout>
    </Preview>
    <h3>{`Vertical`}</h3>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <ButtonGroup mdxType="ButtonGroup">
      <ButtonPrimary mdxType="ButtonPrimary">Button</ButtonPrimary>
      <ButtonPrimary mdxType="ButtonPrimary">Button</ButtonPrimary>
      <ButtonPrimary mdxType="ButtonPrimary">Button</ButtonPrimary>
    </ButtonGroup>
    <ButtonGroup mdxType="ButtonGroup">
      <Button size="large" mdxType="Button">
        <Icon name="heart" size="medium" mdxType="Icon" />
      </Button>
      <Button size="large" mdxType="Button">Button</Button>
    </ButtonGroup>
    <ButtonGroup mdxType="ButtonGroup">
      <ButtonPrimary size="small" isDisabled mdxType="ButtonPrimary">
        Button
      </ButtonPrimary>
      <ButtonPrimary size="small" mdxType="ButtonPrimary">Button</ButtonPrimary>
      <ButtonPrimary size="small" iconPosition="left" mdxType="ButtonPrimary">
        <Icon name="heart" className="icon--left" mdxType="Icon" />
        Button
      </ButtonPrimary>
    </ButtonGroup>
  </ButtonLayout>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<ButtonGroup />" component={ButtonLayouts} excludes={["type"]} mdxType="ComponentDocs" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;